import React from 'react';

function Home() {
  const royalBlue = '#002366';
  const background = '#f8faff';

  return (
    <section
      style={{
        minHeight: '100vh',
        width: '100%',
        padding: '5vw',
        fontFamily: 'Times New Roman, serif',
        backgroundColor: background,
        boxSizing: 'border-box',
        overflowY: 'auto',
      }}
    >
      <div
        style={{
          maxWidth: '960px',
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          color: '#2c2c2c',
          fontSize: '1.1rem',
          lineHeight: '1.8',
        }}
      >
        <h2
          style={{
            textAlign: 'center',
            marginBottom: '30px',
            color: royalBlue,
            fontWeight: 'bold',
            fontSize: 'clamp(1.3rem, 3vw, 1.8rem)',
          }}
        >
          WELCOME TO KALYANASUNDARAM STHAPATHI PRIVATE LIMITED
        </h2>

        <h1
          style={{
            textAlign: 'center',
            color: royalBlue,
            fontWeight: 'bold',
            fontSize: 'clamp(1.2rem, 2.5vw, 1.6rem)',
            marginBottom: '20px',
          }}
        >
          Consult the Best Sthapathi for Traditional Temple Design
        </h1>

        <p style={{ marginBottom: '25px' }}>
          Are you searching for an experienced Sthapathi to design a traditional South Indian temple?
          <strong> Kalyanasundaram</strong> is a renowned temple architect specializing in Vastu-compliant temple
          layouts, Garbhagriha construction, and traditional <strong>Shilpa Shastra</strong> principles.
          Book a <strong>free consultation</strong> today to bring your divine vision to life.
        </p>

        <p style={{ marginBottom: '20px' }}>
          “Kalyanasundaram Sthapathi Private Limited” was established in 1997 in Chennai (Tamil Nadu, India).
          We are one of the leading temple architects and executors of Hindu Temples. Our expertise spans across
          divine sculptures, traditional temple architecture, mural arts, and flawless temple construction services
          for both residential and corporate sectors.
        </p>

        <p style={{ marginBottom: '20px' }}>
          To design and develop a qualitative range of decorative sculptures and mural panels, we have established
          a refined manufacturing unit equipped with the latest machinery and carpentering tools. Our expert
          professionals ensure industry-standard quality at every stage. We have appointed a team of creative
          sthapathis and engineers to handle Temple Architecture and Building Construction Services.
          They work in close coordination with our clients to meet exact specifications. We take pride in timely
          project delivery and maintaining the highest standards of client satisfaction.
        </p>

        <p>
          Under the visionary leadership of our Director, <strong>Mr. S.B. Kalyanasundaram Sthapathi</strong>,
          the company has reached new heights. His deep industry knowledge motivates our entire team to consistently
          deliver exceptional results and preserve the rich heritage of temple architecture.
        </p>
      </div>
    </section>
  );
}

export default Home;






